import { AppButtonIcon } from "@components"
import React from "react"
import { batch } from "@preact/signals-react"
import {openEvolutionModal} from "../../@signals";

export default function AnalyzerEvolutionChartActions({ setIsVisible, setIsLoading }) {

	const handleButtonClick = () => batch(() => {
		setIsLoading(true)
		setTimeout(() => {
			setIsLoading(false)
		}, 100)
		setIsVisible()
	})


	return <>
		<AppButtonIcon
			sx={{ mr: 4 }}
			iconProps={{ iconWeight: "solid" }}
			tooltip="Show/Hide Legend"
			onClick={handleButtonClick}
			icon="eye-slash"
		/>
		<AppButtonIcon
			sx={{ mr: 4 }}
			onClick={() => openEvolutionModal.value = {}}
			iconProps={{ iconWeight: "solid" }}
			tooltip="Close Modal"
			icon="xmark"
		/>
	</>
}